// extracted by mini-css-extract-plugin
export default {"container":"rG-z","disabled":"sG-z","bgBlack":"tG-z","content":"uG-z","countdown":"vG-z","topCaption":"wG-z","topHeading":"xG-z","heading":"yG-z","copy":"zG-z"};